







/* General */
import Vue from 'vue'

/* Mixins */

/* Components */

/* Helpers */

/* Data types */

/* API */

export default Vue.extend({
  name: 'BepOptionsTab',

  props: {
    label: {
      type: String,
      default: '',
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    useAddButton: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      // TO DO
    }
  },

  computed: {},

  methods: {
    handleClick() {
      if (!this.isDisabled) {
        this.$emit('clicked')
      }
    },
  },
})
